
import { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { NotificationHistory } from "@/components/notifications/NotificationHistory";
import { PageBackground } from "@/components/ui/page-background";
import { useNotifications } from "@/hooks/use-notifications";
import { RemindersSection } from "@/components/home/RemindersSection";

const Notifications = () => {
  const { markAllAsRead } = useNotifications();

  useEffect(() => {
    // Marquer toutes les notifications comme lues lors de l'accès à cette page
    if (markAllAsRead) {
      markAllAsRead.mutate();
    }
  }, [markAllAsRead]);

  return (
    <div className="container mx-auto px-4 py-8">
      <PageBackground variant="default" intensity="medium" />
      
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Notifications</h1>
        <p className="text-muted-foreground mt-2">
          Suivez vos notifications et restez informé
        </p>
      </div>
      
      <div className="space-y-6">
        <RemindersSection />
        
        <Card>
          <CardHeader>
            <CardTitle>Historique des notifications</CardTitle>
          </CardHeader>
          <CardContent>
            <NotificationHistory />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Notifications;
